import axiosPrivate from "../../../api/axiosPrivate";
import { MAKE_PAYMENT, MAKE_SAVINGS_PAYMENT, REVERSE_CUSTOMER_TRANSACTION, REVERSE_SAVINGS_TRANSACTION } from "../../../api/constant";


const makePayment= async (data) => {
    const response = await axiosPrivate.post(`${MAKE_PAYMENT}`, data)
    return response.data;
}

const reverseTransaction= async (data) => {
    const response = await axiosPrivate.get(`${REVERSE_CUSTOMER_TRANSACTION}?transaction_id=${data.transaction_id}&policy_app_no=${data.policy_app_no}&customer_id=${data.customer_id}`)
    return response.data;
}

const makeSavingsPayment= async (data) => {
    const response = await axiosPrivate.post(`${MAKE_SAVINGS_PAYMENT}`, data)
    return response.data;
}

const reverseSavingsTransaction= async (data) => {
    const response = await axiosPrivate.get(`${REVERSE_SAVINGS_TRANSACTION}?transaction_id=${data.transaction_id}&staff_id=${data.staff_id}&customer_id=${data.customer_id}&policy_app_no=${data.policy_app_no}`)
    return response.data;
}

const transactionService = {
    makePayment,
    reverseTransaction,
    makeSavingsPayment,
    reverseSavingsTransaction
}

export default transactionService